import { useEffect, useState } from "react";
import { api } from "@/lib/api";

const key = (uid) => `mpl-offers-seen-${uid}`;
const seen = (uid) => { try { return JSON.parse(localStorage.getItem(key(uid)) || "[]"); } catch { return []; } };

export async function markOffersSeen(uid) {
  const { data } = await api.get("/ads/offers-status").catch(() => ({ data: { ids: [] } }));
  localStorage.setItem(key(uid), JSON.stringify(data.ids));
  window.dispatchEvent(new Event("mpl-offers-seen"));
}

export function useNewOffers(user) {
  const [fresh, setFresh] = useState(false);
  const uid = user?.id;
  const skip = !uid || user.role === "partner";
  useEffect(() => {
    if (skip) return undefined;
    let ids = [];
    const check = () => { const s = new Set(seen(uid)); setFresh(ids.some((i) => !s.has(i))); };
    api.get("/ads/offers-status").then(({ data }) => { ids = data.ids || []; check(); }).catch(() => {});
    window.addEventListener("mpl-offers-seen", check);
    return () => window.removeEventListener("mpl-offers-seen", check);
  }, [uid, skip]);
  return fresh;
}
